import { attributesConditionsMatch } from 'shared-helpers/customAttributes';

import type { AttributeCondition, RequestUser } from 'shared-types';

interface Params {
  individualAchievementUserId?: number;
  supervisorAllowed: boolean;
  supervisorConditions: AttributeCondition[];
  user: RequestUser;
}

const isUserAllowedToHandleIndividualAchievementRequests = ({
  individualAchievementUserId,
  supervisorAllowed,
  supervisorConditions = [],
  user
}: Params) => {
  // superadmins are always allowed to handle requests
  if (user?.roles.includes('superadmin')) return true;

  // user can always handle own request
  if (individualAchievementUserId === user.id) return true;

  // check if user supervisor can handle requests in general
  if (user?.roles.includes('supervisor') && supervisorAllowed) {
    if (supervisorConditions?.length) {
      if (
        attributesConditionsMatch({
          conditions: supervisorConditions,
          customAttributeValues: user.customAttributes,
          user
        })
      ) {
        // user is a supervisor and matches required attribute conditions for handling requests
        return true;
      }
    } else {
      // user is a supervisor and site settings allow supervisors to handle requests unconditionally
      return true;
    }
  }

  // user is not allowed to handle requests
  return false;
};

export default isUserAllowedToHandleIndividualAchievementRequests;
